import { tenantQuotingSettingsQuery } from "@common/api/quoting/settings"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { PageContent } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { CustomerApprovalForm } from "./customer-approval/-components/form/customer-approval-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/customer-approval",
)({
  staticData: {
    breadcrumb: [{ label: "Quoting - Customer approval" }],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "quote_settings:read",
      "/settings/workspace/general",
    ),
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(tenantQuotingSettingsQuery()),
  component: CustomerApprovalPage,
})

function CustomerApprovalPage(): React.ReactElement {
  const { data: settings } = useSuspenseQuery(tenantQuotingSettingsQuery())
  const showToast = useCustomToast()

  return (
    <PageContent>
      <CustomerApprovalForm
        settings={settings}
        onSave={() =>
          showToast("Saved", "Customer approval settings updated.", "success")
        }
      />
    </PageContent>
  )
}
